import React, { memo } from "react";
import { deepCompareProps } from "utils/memo/deepCompare";

const arePropsEqual = (prev, next) => {
    return deepCompareProps(
        [
            "inputData.onFilterChange",
            "inputData.filterArrayLength",
            "inputData.filter.value",
            "inputData.filter.filterType",
            "inputData.filterChoices",
            "inputData.isFilterDisabled",
        ],
        prev,
        next
    );
};

export const memoFilter = (component) => memo<any>(component, arePropsEqual);
